export default __webpack_public_path__ + "static/media/stars.bd1e0671.svg";